import { module as Module } from 'modujs'

export default class extends Module {
    constructor(m) {
        super(m)
        
        this.events = {
            click: {
                link: 'onClick'
            }
        }

        this.$list = this.$('list')[0]
        this.$links = Array.from(this.$('link'));
    }

    onClick(e) {
        e.preventDefault();
        e.stopPropagation();

        this.call('scrollTo', { target: e.currentTarget.getAttribute('href'), offset: -120 }, 'Scroll')
    }

    setActiveSectionById(id) {
        const oldActive = this.$links.find(item => item.classList.contains('is-active'))
        oldActive?.classList.remove('is-active');
        const newActive = this.$links.find(item => item.getAttribute('href') == '#'+id)
        newActive?.classList.add('is-active')

        if(newActive) {
            this.$list.scrollTo({
                left: newActive.offsetLeft - this.$links[0].offsetLeft,
                behavior: 'smooth'
            });
        }
    }

    onSectionChange(e) {
        if(e.way == 'enter') {
            this.setActiveSectionById(e.target.id)
        }
    }
}
